<template>
<div class="col-md-4">
    <div class="card">
        <h3 class="card-title">
            {{ event.title }}
        </h3>
        <p class="card-text">
            {{ event.description }}
        </p>
        <ul>
            <li>
                Date: {{ event.date }}
            </li>
            <li>
                Location: {{ event.location }}
            </li>
            <li>
                Host: {{ event.email }}
            </li>
        </ul>
    </div>
</div>
</template>

<script>
export default {
    props: ['event']
}
</script>



// WEBPACK FOOTER //
// src/components/EventItem.vue